<div class="main-layout-wrap d-flex flex-column"  [ngClass]="{'mobile-mode':sharedSvc.isMobileMode(), 'app-header-fixed': fixedHeader}">
  <!-- main-header -->
  <main-header></main-header>
  <!-- end main-header -->
  <!-- main-content -->
  <div class="page-content flex-fill">
    <div class="">
      <main class="main">
        @if (show) {
          <breadcrumbs [hidden]="isRestrictedLogin" class="d-none d-lg-block app-content-width container-fluid"></breadcrumbs>
        }
        <div class="page">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>
  <cookie-disclaimer></cookie-disclaimer>
  <!-- end main-content -->
  <!-- main-footer -->
  @if (!isRestrictedLogin) {
    <main-footer></main-footer>
  }
  <!-- end main-footer -->
</div>

